var map = {
	"./de.json": [
		1224,
		1
	],
	"./de_CH.json": [
		1267,
		54
	],
	"./en.json": [
		663
	],
	"./en_CA.json": [
		1268,
		0
	],
	"./en_CH.json": [
		1225,
		1
	],
	"./en_GB.json": [
		1269,
		0
	],
	"./fr.json": [
		1270,
		55
	],
	"./fr_CA.json": [
		1271,
		0
	],
	"./it.json": [
		1272,
		56
	],
	"./it_CH.json": [
		1226,
		1
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 751;
module.exports = webpackAsyncContext;